import type { Dictionary } from "../../types";
import { common } from "./common";
import { home } from "./home";
import { blog } from "./blog";
import { privacy } from "./privacy";
import { mobilePrivacy } from "./mobilePrivacy";
import { impressum } from "./impressum";
import { releases } from "./releases";
import { posts } from "./posts";

export const zh: Dictionary = { common, home, blog, privacy, mobilePrivacy, impressum, posts, releases };
